import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function BigText({ text, containerClass, textClass}) {
    return (
        <Container className={`container my-2 my-md-5 ${containerClass}`}>
            <Row className="row">
                <Col xs={12} md={10}>
                    <h2 className={`h1 ${textClass}`} dangerouslySetInnerHTML={{ __html: text}}></h2>
                </Col>
            </Row>
        </Container>
    )
}